import {
  radioSchema,
  radioUI,
} from 'platform/forms-system/src/js/web-component-patterns';
import { DEFAULT_TITLE_OPTS, titleWithNameUI } from '../../definitions';
import content from '../../locales/en/content.json';
import { validateSpousalRelationship } from '../../utils/validation';

const TITLE_TEXT = content['applicants--sponsor-relationship-title'];
const INPUT_LABEL = content['applicants--sponsor-relationship-label'];
const HINT_TEXT = content['applicants--sponsor-relationship-hint'];

const SCHEMA_LABELS = {
  spouse: content['applicants--sponsor-relationship-option--spouse'],
  child: content['applicants--sponsor-relationship-option--child'],
};
const SCHEMA_ENUM = Object.keys(SCHEMA_LABELS);

export default {
  uiSchema: {
    ...titleWithNameUI(TITLE_TEXT, null, DEFAULT_TITLE_OPTS.applicant),
    applicantRelationshipToSponsor: {
      ...radioUI({
        title: INPUT_LABEL,
        labels: SCHEMA_LABELS,
        hint: HINT_TEXT,
        useAllFormData: true,
      }),
      'ui:validations': [validateSpousalRelationship],
    },
  },
  schema: {
    type: 'object',
    required: ['applicantRelationshipToSponsor'],
    properties: {
      applicantRelationshipToSponsor: radioSchema(SCHEMA_ENUM),
    },
  },
};
